export const frToasts = {
    'toast.success.update': 'Données mises à jour',
    'toast.success.create': 'Création avec succès',
    'toast.success.manualNotif': 'Relance effectuée.',
    'toast.success.publish': "L'élément a été publié",
    'toast.success.unpublish': "L'élément a été dépublié",
    'toast.success.audienceFromQuestion':
        "L'audience a été mise à jour dans l'arbre (n'oubliez pas de sauvegarder)",

    'toast.apiErrors.defaultMessage':
        "Quelque chose ne s'est pas passé comme prévu, merci de réessayer",
    'toast.error.invalidForm': 'Formulaire invalide',
    'toast.apiErrors.EMAIL_NOT_FOUND': "L'adresse email n'a pas été trouvée",
    'toast.apiErrors.GROUP_HAVE_CHILDREN': "Ce groupe n'est pas vide, il ne peut pas être supprimé",
    'toast.apiErrors.FRONT_USER_HAVE_SHOPS':
        'Cet utilisateur est associé à des centres, il ne peut pas être supprimé',
    'toast.apiErrors.FRONT_USER_EMAIL_ALREADY_EXISTS':
        'Un utilisateur avec le même email existe déjà',
    'toast.apiErrors.BACKOFFICE_USER_EMAIL_ALREADY_EXISTS':
        'Un utilisateur avec le même email existe déjà',
    'toast.apiErrors.UNABLE_TO_UPLOAD_DOCUMENT':
        "Nous n'avons pas réussi à envoyer le document, merci de réessayer dans quelques instants",
    'toast.apiErrors.INVALID_DOCUMENT_FORMAT':
        "Le format de ce document n'est supporté, seuls les documents PDF sont autorisés",
    'toast.apiErrors.DOCUMENT_URL_ERROR':
        "Impossible de récupérer le document à partir de l'url indiquée",
    'toast.apiErrors.UNABLE_TO_UPLOAD_IMAGE':
        "Nous n'avons pas réussi à envoyer l'image, merci de réessayer dans quelques instants",
    'toast.apiErrors.INVALID_IMAGE_FORMAT':
        "Nous n'avons pas pu traiter cette image, son format ne semble pas valide",
    'toast.apiErrors.IMAGE_URL_ERROR': "Impossible de récupérer l'image à partir de l'url indiquée",
    'toast.apiErrors.EXTERNAL_REFERENCE_INVALID_FORMAT':
        "Le format de la référence externe n'est pas valide. La référence externe ne peut contenir que des lettres, des chiffres et les caractères '_', '-' et '.'",
    'toast.apiErrors.GEOCODING_CANT_CONTACT_API':
        'Une erreur est survenue lors de la récupération de la position GPS',
    'toast.apiErrors.GEOCODING_INVALID_RESULT_API':
        'Une erreur est survenue lors de la récupération de la position GPS',
    'toast.apiErrors.GEOCODING_NO_RESULT_FOUND':
        "Aucune position n'a été trouvée pour cette adresse",

    'toast.apiErrors.QUESTIONNAIRE_PUBLISHED_CANT_EDIT':
        "Impossible de modifier la structure d'un questionnaire après publication",
    'toast.apiErrors.QUESTIONNAIRE_MISSING_QUESTIONS':
        'Le questionnaire doit contenir au moins une question',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_CHOICE_LABEL_MISSING':
        'Chaque réponse possible doit avoir un libellé',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_MISSING_QUESTION':
        'Un libellé de question doit être défini pour chaque question',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_MISSING_TITLE':
        'Un titre doit être défini pour chaque question',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_NOT_ENOUGH_CHOICES':
        'Chaque question choix doit proposer au moins deux réponses possibles',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_SINGLE_CHOICE_ACTION_WHEN_SELECTED_UNDEFINED':
        "Le comportement de question suivante n'est pas bien défini pour une des question à choix unique",
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_SINGLE_CHOICE_GO_TO_QUESTION_ID_BAD_REFERENCE':
        "Le comportement de question suivante n'est pas bien défini pour une des question à choix unique",
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_SINGLE_CHOICE_GO_TO_QUESTION_ID_UNDEFINED':
        "Le comportement de question suivante n'est pas bien défini pour une des question à choix unique",
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_SINGLE_CHOICE_LABEL_NOT_DEFINED':
        'Chaque réponse possible doit avoir un libellé',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_CHOICE_NOT_FOUND':
        'Aucune réponse ne correspond à cette référence',
    'toast.apiErrors.QUESTIONNAIRE_QUESTION_CHOICE_AMBIGUOUS_EXTERNAL_REFERENCE':
        'Plusieurs réponses correspondent à cette référence',

    'toast.apiErrors.INVALID_EXTERNAL_REFERENCE':
        "Le format de la référence externe n'est pas valide. La référence externe ne peut contenir que des lettres, des chiffres et les caractères '_', '-' et '.'",
    'toast.apiErrors.CANT_EDIT_PRICE_RESPONSE':
        'Cet élément a déjà des réponses. Vous ne pouvez plus changer le prix',

    'toast.apiErrors.DUPLICATED_EXTERNAL_REFERENCE':
        'Cette référence existe déjà pour un autre magasin',
    'toast.apiErrors.GENERIC_PRICE_MUST_NOT_BE_FILLED':
        'Le prix doit être défini pour chaque produit',
    'toast.apiErrors.NORMAL_BOUGHT_PRICE_MUST_BE_FILLED':
        "Le prix d'achat doit être défini pour chaque produit",
    'toast.apiErrors.NORMAL_SELL_PRICE_MUST_BE_FILLED':
        'Le prix de vente doit être défini pour chaque produit',

    'toast.apiErrors.WEAK_PASSWORD': 'Le mot de passe est trop faible',

    'toast.apiErrors.MISSING_PERMISSIONS':
        "Vous n'avez les permissions nécessaires pour notifier cette audience",

    'toast.apiErrors.NEWS_ALREADY_PUBLISHED': 'cet événement a déjà été publié',

    // CUSTOM TOAST ERRORS
    'toast.apiErrors.REFERENCE_NO_OPERATION': 'Aucune opération trouvée avec cette référence',
    'toast.apiErrors.REFERENCE_NO_QUESTION': 'Aucune question trouvée avec cette référence',

    'toast.apiErrors.ENTITY_WAS_ONCE_PUBLISHED': "L'élément a déjà été publié",

    'toast.apiErrors.STATS_ONLY_FOR_GHOST':
        'Ce contenu ne possède pas de statistiques car il ne concerne que des centres invisibles.',

    'toast.apiErrors.MISSING_AUDIENCE': "Il n'y a pas d'audience définie pour ce contenu",
    'toast.apiErrors.MISSING_ROLE_AUDIENCE': "Il n'y a pas de rôle défini pour ce contenu",
    'toast.apiErrors.ENTITY_NOT_PUBLISHED': "Le contenu n'est pas publié",

    //* TO TRAD
    'toast.success.comment.published': 'Le commentaire a été publié',
    'toast.success.comment.disabled': 'Le commentaire a été désactivé',
    'toast.apiErrors.EMPTY_COMMENT': 'Le commentaire ne doit pas être vide',

    'toast.apiErrors.EMAIL_ALREADY_INITIALIZED':
        'Le mot de passe de cet utilisateur est déjà initialisé.',
};
